import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  lastActiveTime: null,
  userData: null,
  isVideoPlaying: false,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      state.userData = action.payload;
      state.lastActiveTime = Date.now();
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.userData = null;
      state.lastActiveTime = null;
    },
    updateLastActiveTime: (state) => {
      state.lastActiveTime = Date.now();
    },
    setVideoPlaying: (state, action) => {
      state.isVideoPlaying = action.payload;
    },
  },
});

export const { login, logout, updateLastActiveTime, setVideoPlaying } = sessionSlice.actions;
export default sessionSlice.reducer;
